import React, { useState } from 'react';
import '../css/FilterModal.css';

const FilterModal = ({ onClose, onOptionsChange }) => {
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({ frequency_band: [] });

  const toggleSubMenu = (menu) => {
    setExpandedMenu(expandedMenu === menu ? null : menu);
  };

  const handleCheckboxChange = (menu, option) => {
    setSelectedOptions((prevSelectedOptions) => {
      const updatedOptions = { ...prevSelectedOptions };
      const selectedIndex = updatedOptions[menu].indexOf(option);
      if (selectedIndex === -1) {
        updatedOptions[menu] = [...updatedOptions[menu], option];
      } else {
        updatedOptions[menu].splice(selectedIndex, 1);
      }
      return updatedOptions;
    });

    // 将更新后的选项状态传递给父组件
    onOptionsChange(selectedOptions);
  };

  return (
    <div className="filter-modal-container">
      <div className="filter-modal-background" onClick={onClose}></div>
      <div className="filter-modal">
        <div className="filter-modal-header">
          <button className="back-button" onClick={onClose}>返回</button>
          <div className="filter-modal-title">筛选</div>
        </div>
        <div className="filter-modal-menu">
          <div className="filter-modal-menu-item" onClick={() => toggleSubMenu('frequency_band')}>
            频段
          </div>
          {expandedMenu === 'frequency_band' && (
            <div className="filter-modal-submenu">
              <div className="filter-modal-submenu-item">
                <input
                  type="checkbox"
                  id="2_4GHz"
                  name="frequency_band"
                  value="2.4GHz"
                  checked={selectedOptions.frequency_band.includes('2.4GHz')}
                  onChange={() => handleCheckboxChange('frequency_band', '2.4GHz')}
                />
                <label htmlFor="2_4GHz">2.4GHz</label>
              </div>
              <div className="filter-modal-submenu-item">
                <input
                  type="checkbox"
                  id="5GHz"
                  name="frequency_band"
                  value="5GHz"
                  checked={selectedOptions.frequency_band.includes('5GHz')}
                  onChange={() => handleCheckboxChange('frequency_band', '5GHz')}
                />
                <label htmlFor="5GHz">5GHz</label>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
